import React, { useState } from "react";
import Header from "../Header/Header"
import PlanTypeButton from "../Button/PlanType"
import MetsSlider from "../Slider/Mets"
import PricingGraph from "../Graph/PricingGraph";
import { marks } from "config/marks";
import "./PricingModel.css"

function PricingModel() {
  const [planType, setPlanType] = useState("Enterprise");
  const [mets, setMets] = useState("50 million");
  const [price, setPrice] = useState(3600);
  const [yAxisCoordinate, setCoordinate] = useState(126)

  const handleClick = (planSelected) => {
    let price;
    if (planSelected === 'Standard') {
      price = marks.find(mark => yAxisCoordinate === mark.yAxisCoordinate)['standardPrice'];
    } else if (planSelected === 'Enterprise') {
      price = marks.find(mark => yAxisCoordinate === mark.yAxisCoordinate)['enterprisePrice'];
    } else {
      price = marks.find(mark => yAxisCoordinate === mark.yAxisCoordinate)['mcPrice'];
    }

    setPrice(price);
    setPlanType(planSelected);

  }

  function handleChange (price, mets,yAxisCoordinate) {
    setPrice(price);
    setMets(mets);
   setCoordinate(yAxisCoordinate)
  }

  return (
    <div className="PricingModel">
      <PlanTypeButton 
        handleClick={handleClick}
      />
      <Header 
        planType={planType} 
        mets={mets} 
        price={price}
      />

      <div className="react-graph-wrapper">
        <div className="react-graph-container">
            <MetsSlider 
              planType={planType} 
              handleChange={handleChange}
            />
            <PricingGraph
              yAxisCoordinate={yAxisCoordinate}
            />
        </div>
      </div>
    </div>
  );
}

export default PricingModel;
